import { render, staticRenderFns } from "./404.vue?vue&type=template&id=19b018f8&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=19b018f8&prod&lang=scss&scoped=true"
import style1 from "./404.vue?vue&type=style&index=1&id=19b018f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b018f8",
  null
  
)

export default component.exports